import { Card, CardContent, Typography, Box, Checkbox, Grid, Container, IconButton, TextField } from "@mui/material";
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';

const CartItem = ({ item, handleChange, inputData }) => {
    // Find the selected item's quantity
    const selectedItem = inputData?.items?.find(i => i.food === item.id);
    const quantity = selectedItem ? selectedItem.quantity : 1;

    // Handle quantity change
    const handleQuantityChange = (newQuantity) => {
        if (newQuantity < 1) return; // Prevent quantity below 1
        handleChange({ target: { name: item.id.toString(), value: newQuantity } });
    };

    return (
        <Card variant="outlined" sx={{ borderRadius: "10px", p: 2, backgroundColor: "#f8f9fc", mb: 2, width: "100%" }}>
            <CardContent sx={{ p: 0 }}>
                <Box display="flex">
                    <Checkbox
                        sx={{ pt: "3px", pl: 0 }}
                        checked={Boolean(selectedItem)}
                        onChange={(e) => handleChange(e, item.id)}
                    />
                    <Typography variant="h6" fontWeight="bold" sx={{ pt: 0 }}>{item.name}</Typography>
                </Box>
                <Box>
                    <Typography variant="body2" color="textSecondary">{item.description}</Typography>
                </Box>

                {/* Quantity Selector */}
                <Box display="flex" alignItems="center" gap={1} mt={1}>
                    <Typography variant="body2">Quantity</Typography>

                    <IconButton size="small" onClick={() => handleQuantityChange(quantity - 1)}>
                        <RemoveIcon />
                    </IconButton>

                    <TextField
                        type="number"
                        value={quantity}
                        onChange={(e) => handleQuantityChange(parseInt(e.target.value) || 1)}
                        inputProps={{ min: 1, style: { textAlign: "center" } }}
                        sx={{ width: "60px", textAlign: "center" }}
                    />

                    <IconButton size="small" onClick={() => handleQuantityChange(quantity + 1)}>
                        <AddIcon />
                    </IconButton>

                    {/* Subtotal */}
                    <Typography variant="body2" fontWeight="bold" textAlign="right">
                        ₹{(item.price * quantity).toFixed(2)}
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    );
};

const Cart = ({ item = [], handleChange, inputData }) => {
    return (
        <Container>
            {item.length === 0 ? <Typography align="center" variant="h6">No Food</Typography> :
                <Grid container spacing={2} justifyContent="space-between">
                    {item.map((foodItem, index) => (
                        <Grid item xs={12} sm={12} md={6} key={index}>
                            <CartItem item={foodItem} handleChange={handleChange} inputData={inputData} />
                        </Grid>
                    ))}
                </Grid>
            }
        </Container>
    );
};

export default Cart;
